<template>
    <v-list id="scroller" class="w-full overflow-y-auto" scroll-region>
        <div
            id="bottom-anchor"
            v-intersect="{
                root: '#scroller',
                handler: bottomVisible,
                options: { rootMargin: '100px', threshold: 0 },
            }"
        ></div>
        <div
            v-if="nextLoading && conversation.message_id"
            class="w-full flex justify-center align-center absolute"
            style="bottom: -1rem"
        >
            <v-progress-circular
                indeterminate
                color="primary"
                class="mr-4"
            ></v-progress-circular>
        </div>
        <div
            v-for="(message, idx) in messageData"
            :key="message.id"
            class="flex flex-col scroller-item custom-animate animate__animated animate__fadeIn"
        >
            <v-list-item
                :id="`message-${message.id}`"
                :class="`thread-${message.thread_id}`"
                class="chat-items soli-round mx-3 px-1 inactive"
            >
                <div class="soli-round soli-grey pa-2 flex justify-end">
                    <v-avatar
                        class="mr-4"
                        :size="$vuetify.breakpoint.smAndUp ? 48 : 36"
                    >
                        <v-img
                            :src="
                                participants.find(
                                    (e) => e.id == message.messagable_id
                                )?.profile_photo_url ??
                                conversationUser.messagable.profile_photo_url
                            "
                        />
                    </v-avatar>
                    <div class="flex flex-col">
                        <div class="flex font-weight-bold items-center">
                            {{
                                participants.find(
                                    (e) => e.id == message.messagable_id
                                )?.messagable_name ??
                                conversationUser.messagable.messagable_name
                            }}<small class="caption ml-2 my-auto"
                                >{{
                                    moment(new Date(message.created_at)).format(
                                        "h:mm A"
                                    )
                                }}
                            </small>
                            <div
                                v-if="
                                    ['sms', 'mms', 'email', 'voice'].includes(
                                        message.channel
                                    )
                                "
                                class="contents"
                            >
                                <div class="mx-2 flex gap-1 items-center">
                                    <v-chip
                                        v-if="message.channel"
                                        x-small
                                        class="font-bold px-2"
                                        :color="channelColors(message.channel)"
                                        >{{ message.channel }}</v-chip
                                    >
                                    <div
                                        v-if="
                                            message.messagable_id ==
                                                conversationUser.messagable_id &&
                                            message.messagable_type ==
                                                conversationUser.messagable_type &&
                                            [
                                                'sms',
                                                'mms',
                                                'email',
                                                'voice',
                                            ].includes(message.channel)
                                        "
                                        class="contents"
                                    >
                                        <v-icon
                                            v-if="message.status == 'delivered'"
                                            x-small
                                            color="success"
                                            class="ml-1"
                                            >done</v-icon
                                        >
                                        <v-icon
                                            v-if="
                                                message.status == 'failed' ||
                                                message.status ==
                                                    'undelivered' ||
                                                !message.status
                                            "
                                            x-small
                                            color="error"
                                            class="ml-1"
                                            >sms_failed</v-icon
                                        >
                                        <v-icon
                                            v-if="message.status == 'opt_out'"
                                            x-small
                                            color="error"
                                            class="ml-1"
                                            >front_hand</v-icon
                                        >
                                    </div>
                                    <!--<v-spacer />
                                    <v-btn
                                        v-if="message.thread_id"
                                        small
                                        icon
                                        color="dark"
                                        ><v-icon small>more_vert</v-icon></v-btn
                                    >-->
                                </div>
                            </div>
                            <v-menu
                                v-if="message.channel !== 'chat'"
                                left
                                offset-y
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        small
                                        icon
                                        v-on="on"
                                        color="dark"
                                        @click="$log(message.id)"
                                    >
                                        <v-icon small>more_vert</v-icon></v-btn
                                    ></template
                                >
                                <v-list>
                                    <v-list-item
                                        :disabled="
                                            !message.thread_messages_count
                                        "
                                        @click="
                                            $emit('changeThread', {
                                                id: message.thread_id,
                                            })
                                        "
                                        >Reply</v-list-item
                                    >
                                    <v-list-item @click="markUnread(message)"
                                        >Mark Unread</v-list-item
                                    >
                                </v-list>
                            </v-menu>
                        </div>
                        <div v-if="message.channel == 'email'" class="caption">
                            {{ `Subject: ${message.subject}` }}
                        </div>
                        <TipTapReader
                            :value="message.content"
                            class="message-content"
                        />

                        <div
                            v-if="message.thread_messages_count > 1"
                            class="caption accent--text cursor-pointer w-max"
                            @click="
                                $emit('changeThread', { id: message.thread_id })
                            "
                        >
                            {{ `${message.thread_messages_count} messages` }}
                        </div>
                    </div>
                </div>
            </v-list-item>
            <MessageDividers
                :isUnread="
                    unreadId ? message.id == unreadId : message.firstUnread
                "
                :isDateIndicator="
                    idx ==
                    messageData.map((e) => e.date).lastIndexOf(message.date)
                "
                :date="message.date"
            />
        </div>
        <div
            id="top-anchor"
            v-intersect="{
                root: '#scroller',
                handler: topVisible,
                options: { rootMargin: '-100px', threshold: 0 },
            }"
        ></div>

        <div
            class="w-full h-full flex justify-center align-center my-4"
            style="min-height: 32px"
        >
            <v-progress-circular
                v-if="previousLoading"
                indeterminate
                color="primary"
                class="mr-4"
            ></v-progress-circular>
        </div>
        <slot></slot>
    </v-list>
</template>

<script>
import TipTapReader from "../Editor/TipTapReader.vue";
import MessageDividers from "./MessageDividers.vue";
export default {
    components: {
        TipTapReader,
        MessageDividers,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        cursor: {
            type: String,
            default: null,
        },
        conversation: {
            type: Object,
            default: () => {},
        },
        conversationUser: {
            type: Object,
            default: () => ({}),
        },
        thread: {
            type: Object,
            default: () => ({}),
        },
        participants: {
            type: Array,
            default: () => [],
        },
        messages: {
            type: Array,
            default: () => [],
        },
        messageCount: {
            type: Number,
            default: 0,
        },
        crmMode: {
            type: Boolean,
            default: false,
        },
        searching: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            //messageData: this.messages.data ?? [],
            nextLoading: false,
            previousLoading: false,
            viewingLatest: true,
            initLoading: true,
            previousMessages: [],
            nextMessages: [],
            unreadId: null,
            scrolling: false,
        };
    },
    computed: {
        messageData() {
            if (!this.messages.length) return [];

            return [
                // ...new Set([
                ...this.nextMessages,
                ...this.messages,
                ...this.previousMessages,
                //]),
            ];
        },
        previousPage() {
            if (!this.messageData.length) return null;
            if (this.scrolling) return;

            return `/messages/${
                this.messageData[this.lastMessage].id
            }/check-previous/${this.thread?.id ?? ""}
            `;
        },
        nextPage() {
            if (!this.messageData.length) return null;
            if (this.scrolling) return;
            return `/messages/${this.messageData[0].id}/check-next/${
                this.thread?.id ?? ""
            }`;
        },
        lastMessage() {
            return this.messageData.length - 1;
        },
    },
    methods: {
        markUnread(message) {
            this.unreadId = message.id;
            this.$emit("handleUnread", {
                conversation: this.conversation,
                messageId: message.id,
            });
            return;
            axios
                .put(
                    `/conversation-user/${this.conversationUser.id}/mark-unread/${message.id}`,
                    {}
                )
                .then(() => {
                    this.$inertia.reload({
                        /*data: {
                            cursor: this.cursor ?? "init",
                        },*/
                        only: [
                            "unreadMessageCount",
                            /*"messages",*/
                            //"index",
                            "searching",
                        ],
                    });
                    this.$emit("unread", message.conversation_id);
                })
                .catch((error) => {
                    this.unreadId = null;
                });
        },
        channelColors(channel) {
            if (channel == "sms") return "secondary";
            if (channel == "mms") return "secondary";
            if (channel == "email") return "accent";
            if (channel == "voice") return "success";
            return "";
        },
        initMessages() {
            if (!this.conversation?.id) {
                this.initLoading = false;
                return this.$emit("loading", false);
            }

            /*if (this.messages[0]?.conversation_id == this.conversation.id) {
                this.initLoading = false;
                return this.$emit("loading", false);
            }*/

            this.$inertia.visit(
                `/inbox/${this.conversation.id}/${this.thread?.id ?? ""}`,
                {
                    data: Object.fromEntries(
                        Object.entries({
                            message_id: this.conversation.message_id ?? null,
                            search: this.searching ?? null,
                            cursor: this.conversation.cursor,
                            cs: this.crmMode
                                ? Number(this.$vuetify.breakpoint.mdAndUp)
                                : null,
                        }).filter(([_, v]) => v != null)
                    ),
                    preserveState: true, //!this.conversation.message_id,
                    only: [
                        "index",
                        "messages",
                        "conversation",
                        "thread",
                        "unreadMessageCount",
                        "messageCount",
                        "newMessageAvailable",
                        "crmClient",
                        "searching",
                    ],
                    onSuccess: () => {
                        if (!this.conversation.message_id) {
                            this.$emit("loading", false);
                            this.initLoading = false;
                        } else {
                            this.scrollToMessage(
                                this.conversation.message_id,
                                "start",
                                this.conversation.latest_message?.thread_id
                            );
                            this.$emit(
                                "input",
                                this.messages.find(
                                    (e) => e.id == this.conversation.message_id
                                )
                            );
                            this.$emit("loading", false);
                            this.initLoading = false;
                        }
                    },
                }
            );
        },
        scrollToMessage(messageId, block = "start", threadId = null) {
            if (!messageId) return;
            this.scrolling = true;

            setTimeout(() => {
                let el = document.getElementById(`message-${messageId}`);
                if (!el) {
                    el = document.querySelector(`.thread-${threadId}`);
                }
                el?.scrollIntoView({
                    behavior: "instant",
                    block: block,
                });
                this.scrolling = false;
            }, 25);
        },
        topVisible(entries, observer) {
            if (entries[0].isIntersecting) {
                this.loadPrevious();
            }
        },
        bottomVisible(entries, observer) {
            if (entries[0].isIntersecting) {
                this.viewingLatest = true;
                this.loadNext();
            } else {
                this.viewingLatest = false;
            }
        },
        messageReceived(message) {
            console.log("messageReceived");
            this.$inertia.reload({
                preserveState: true,
                preserveScroll: true,
                /*data: {
                    cursor: this.cursor,
                },*/
                only: [
                    "index",
                    "conversation",
                    "unreadMessageCount",
                    "messageCount",
                    "newMessageAvailable",
                    "crmClient",
                    "searching",
                    this.viewingLatest ? "messages" : null,
                ],
                onFinish: () => {
                    this.$emit("loading", false);
                },
            });
        },
    },
    created() {
        this.loadPrevious = this.throttle(() => {
            if (this.messageData.length == this.messageCount) return;
            if (this.messages.length < 25) return; // match server pagination to avoid unnecessary calls
            if (!this.previousPage) return;
            if (this.initLoading) return;

            this.previousLoading = true;

            axios.get(this.previousPage).then((resp) => {
                this.previousMessages = [
                    ...new Set([...this.previousMessages, ...resp.data]),
                ];
                if (resp.data.length) {
                    this.scrollToMessage(resp.data[0].id, "start");
                }
                this.previousLoading = false;
            });
        });

        this.loadNext = this.throttle(() => {
            if (this.messageData.length == this.messageCount) return;
            if (!this.nextPage) return;
            if (this.initLoading) return;

            this.nextLoading = true;

            const currentMessageId = this.messageData[0].id;

            axios.get(this.nextPage).then((resp) => {
                this.nextMessages = [
                    ...new Set([...resp.data, ...this.nextMessages]),
                ];
                if (resp.data.length) {
                    this.scrollToMessage(currentMessageId, "end");
                }
                this.nextLoading = false;
            });
        });

        this.initMessages();
    },
    beforeDestroy() {
        this.loadPrevious = null;
        this.loadNext = null;
    },
};
</script>

<style scoped>
#bottom-anchor {
    overflow-anchor: auto;
    height: 1px;
}

#top-anchor {
    overflow-anchor: auto;
    height: 1px;
}

#scroller * {
    overflow-anchor: none;
    /*display: flex;*/
    transform: translateZ(0);
}

#scroller {
    flex: 1 1 0;
    flex-direction: column-reverse;
    display: flex;
    position: relative;
    overflow-y: auto;
    justify-content: flex-start;
    overflow-anchor: auto;
}

.chat-items {
    flex: 0;
    min-height: unset;
}

.scroller-item {
    flex-direction: column-reverse;
    justify-content: flex-start;
    flex: 0;
}

/*.content {
    white-space: pre;
    word-wrap: break-word;
    font-family: inherit;
}*/

.message-content iframe {
    border-radius: 20px;
    padding: 8px 4px;
}

@media screen and (max-width: 600px) {
    .message-content iframe {
        height: 200px;
    }
}

.active-thread {
    margin-left: 1.8rem;
    border-left: 4px solid #228cbd;
    padding-left: 1rem;

    @media screen and (min-width: 600px) {
        padding-left: 1.8rem;
    }
}

.custom-animate.animate__animated.animate__fadeIn {
    --animate-duration: 0.3s;
}
</style>
